import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import "./index.scss";
import { useNavigate } from "react-router-dom";

const PromoSection = () => {
  const navigate = useNavigate();
  return (
    <div className="promo-section">
      <Row className="align-items-center">
        {/* Texte gauche */}
        <Col md={4} className="promo-left order-2 order-md-1">
          <p>
            Des soins naturels et innovants, formulés en Espagne, pour sublimer
            votre peau et vos cheveux en douceur.
          </p>
          <Button
            className="promo-btn"
            onClick={() => {
              navigate("/all-products");
              window.scrollTo(0, 0);
            }}>
            VOIR TOUS LES PRODUITS
          </Button>
        </Col>

        {/* Texte droite */}
        <Col md={8} className="promo-right order-1 order-md-2">
          <h2>
            SHAMPOINGS NATURELS,
            <br /> CRÈMES VISAGE, SOINS CORPS.
          </h2>
        </Col>
      </Row>
    </div>
  );
};

export default PromoSection;
